import routing from './borne.routes';
import admin from './admin';
import main from './main';
import categories from './categories';
import langues from './langues';
import collecte from './collecte';
import formation from './formation';
import questions from './questions';
import badge from './badge';
import { BorneFactory } from './borne.factory';
import moment from 'moment';

export default angular.module('aperamApp.borne', ['ui.bootstrap-slider', admin, main, categories, langues, collecte, formation, questions, badge])
  .config(routing)
  .factory('Borne', BorneFactory)
  .component('timer', {
    template: require('./timer.html'),
    controller: function ($scope, $filter, $interval, Borne) {
      $scope.$on('$destroy', () => {
        $interval.cancel();
      })
      $interval(() => {
        if(Borne.Poste.selectedCategorie) $scope.showTimer = (Borne.Poste.timer <= (Borne.Poste.selectedCategorie.standbyTimer/4));
        $scope.timer = $filter('dynamic')(Borne.Poste.Langue.dictionnary.general.deconnexion)
      },1000);
    }
  })
  .filter('dynamic', function(Borne){
    function dynamic(value, categorie){
      if(value && value.includes('%CATEGORIE%')) value = value.replace('%CATEGORIE%', categorie.name);
      if(value && value.includes('%SITE%')) value = value.replace('%SITE%', Borne.Poste.Site.name);
      if(value && value.includes('%TIME%')) value = value.replace('%TIME%', Borne.Poste.timer / 1000);
      if(Borne.Poste && Borne.Poste.Session && Borne.Poste.Session.collecte && value && value.includes('%NOM%')) value = value.replace('%NOM%', Borne.Poste.Session.collecte.Nom);
      if(Borne.Poste && Borne.Poste.Session && Borne.Poste.Session.collecte && value && value.includes('%PRENOM%')) value = value.replace('%PRENOM%', Borne.Poste.Session.collecte.Prenom);
      return value
    }
    dynamic.$stateful = true;
    return dynamic
  })
  .filter('categorieTrans', function(Borne){
    return function(categorie){
      if(categorie.traductions) return _.find(categorie.traductions, ['id',Borne.Poste.Langue.id]).categoryName;
      else return 'Pas traduit.';
    }
  })
  .filter('dataTrans', function(Borne){
    return function(data){
      if(data.traductions) return _.find(data.traductions, ['id',Borne.Poste.Langue.id]).dataName;
      else return 'Pas traduit.';
    }
  })
  .run(function($rootScope, Borne) {
    'ngInject';
    $rootScope.$on('$stateChangeStart', function(event, next, nextParams, current) {
      if(next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/borne/index.js